export function ManageCookies() {
  return (
    <button
      type="button"
      // This is the hook for the OneTrust SDK to listen for click events on
      // the element, not for styling purposes.
      className="ot-sdk-show-settings"
      // OneTrust requires that you hide your "Manage cookies" button with
      // inline styles, and then it removes the `display: none` after the
      // script has loaded.
      style={{ display: "none" }}
    >
      Manage cookies
    </button>
  );
}
